import revive_payload_client_4sVQNw7RlN from "/app/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/app/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/app/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/app/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/app/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/app/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/app/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import components_plugin_KR1HBZs4kY from "/app/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/app/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_jg3TSEXw60 from "/app/node_modules/@hebilicious/vue-query-nuxt/dist/runtime/plugin.mjs";
import switch_locale_path_ssr_5csfIgkrBP from "/app/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_sq1MuCrqbC from "/app/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import cookieconsent_client_xkNjjSgDDv from "/app/src/plugins/cookieconsent.client.ts";
import directives_client_GD2ZSmh1zM from "/app/src/plugins/directives.client.ts";
import google_recaptcha_client_aGld8eGgvB from "/app/src/plugins/google-recaptcha.client.ts";
import toastify_client_os8XWI7qoq from "/app/src/plugins/toastify.client.ts";
import vue_pdf_embed_client_mWeA6252Z5 from "/app/src/plugins/vue-pdf-embed.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_jg3TSEXw60,
  switch_locale_path_ssr_5csfIgkrBP,
  i18n_sq1MuCrqbC,
  cookieconsent_client_xkNjjSgDDv,
  directives_client_GD2ZSmh1zM,
  google_recaptcha_client_aGld8eGgvB,
  toastify_client_os8XWI7qoq,
  vue_pdf_embed_client_mWeA6252Z5
]